import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { WebClientService } from '../../services/webclient-settings.service';
/**
 * SingleConsultationComponent
 */
let UnderComponent = class UnderComponent {
    constructor(wcss) {
        this.wcss = wcss;
    }
    ngOnInit() {
    }
};
UnderComponent.ctorParameters = () => [
    { type: WebClientService }
];
UnderComponent = __decorate([
    Component({
        selector: 'ecd-under',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./under.component.html")).default
    })
], UnderComponent);
export { UnderComponent };
